import React from "react";
import './style.css';

export default function LoadingCamp() {
  return (
    <div className="loading-overlay">
      <main className="container">
        <p className="title">شفا33</p>
        <div className="heartbeatloader">
          <svg className="svgdraw" width="100%" height="100%" viewBox="0 0 150 400" xmlns="http://www.w3.org/2000/svg" >
            <path className="path" d="M 0 200 l 40 0 l 5 -40 l 5 40 l 10 0 l 5 15 l 10 -140 l 10 220 l 5 -95 l 10 0 l 5 20 l 5 -20 l 30 0" fill="transparent" />
          </svg>
          {/* <div class="innercircle heart"></div> */}
          {/* <div class="outercircle"></div> */}
        </div>
        <section className="animation">
          <div className="first"><div>سیستم جامع درمان و سلامت</div></div>
          <div className="second"><div>پرونده الکترونیکی سلامت شفا۳۳</div></div>
          <div className="third"><div>شرکت نوین درمانگران آلا اصفهان</div></div>
        </section>
      </main>
    </div>
  );
}
